import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { getIcon } from '../../../utils/IconHandler';

const RejectProformaModal = ({ open, onClose, proforma, onReject }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  if (!proforma) return null;

  const handleReject = async () => {
    try {
      setLoading(true);
      await onReject(proforma);
      onClose();
    } catch (error) {
      console.error('Error rejecting proforma:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {getIcon('close')}
          {t('reject_order')}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {t('reject_proforma_confirm_message')}
        </Alert>
        <Typography variant="body2" color="text.secondary">
          {t('proforma_number')}: {proforma.id}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t('cancel')}
        </Button>
        <LoadingButton
          onClick={handleReject}
          loading={loading}
          color="error"
          variant="contained"
        >
          {t('reject_order')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default RejectProformaModal;
